// ### Accordion Script ###
let animationInProgress = false;

// slideUp function
function slideUp(target, parent, duration = 300) {

    if (target) {
        animationInProgress = true;
        target.style.height = target.offsetHeight + 'px';
        parent.style.pointerEvents = "none";

        window.setTimeout(() => {
            target.style.overflow = 'hidden';
            target.style.boxSizing = 'border-box';
            target.style.transitionProperty = "height, margin, padding";
            target.style.transitionDuration = duration + 'ms';
            target.style.paddingTop = '0';
            target.style.paddingBottom = '0';
            target.style.marginTop = '0';
            target.style.marginBottom = '0';
            target.style.height = '0';
        }, 100);
        window.setTimeout(() => {
            target.style.display = 'none';
            target.style.removeProperty('height');
            target.style.removeProperty('padding-top');
            target.style.removeProperty('padding-bottom');
            target.style.removeProperty('margin-top');
            target.style.removeProperty('margin-bottom');
            target.style.removeProperty('transition-duration');
            target.style.removeProperty('transition-property');
            parent.style.removeProperty('pointer-events');
            animationInProgress = false;

            target.parentNode.parentNode.querySelector('details').removeAttribute('open');

        }, duration + 100);
    }

}

// slideDown function
function slideDown(target, parent, duration = 300) {
    if (target) {
        target.parentNode.parentNode.querySelector('details').setAttribute('open', "true");

        animationInProgress = true;
        target.style.removeProperty('display');
        parent.style.pointerEvents = "none";
        let display = window.getComputedStyle(target).display;

        if (display === 'none')
            display = 'block';

        target.style.display = display;
        let height = target.offsetHeight;
        target.style.height = '0';
        target.style.paddingTop = '0';
        target.style.paddingBottom = '0';
        target.style.marginTop = '0';
        target.style.marginBottom = '0';

        window.setTimeout(() => {
            target.style.overflow = 'hidden';
            target.style.boxSizing = 'border-box';
            target.style.transitionProperty = "height, margin, padding";
            target.style.transitionDuration = duration + 'ms';
            target.style.height = height + 'px';
            target.style.removeProperty('padding-top');
            target.style.removeProperty('padding-bottom');
            target.style.removeProperty('margin-top');
            target.style.removeProperty('margin-bottom');
        }, 100);
        window.setTimeout(() => {
            target.style.removeProperty('height');
            target.style.removeProperty('transition-duration');
            target.style.removeProperty('transition-property');
            parent.style.removeProperty('pointer-events');
            animationInProgress = false;
        }, duration + 100);
    }
}

// slideToggle function
function slideToggle(target, parent, duration = 300) {

    if (target && !animationInProgress) {
        if (window.getComputedStyle(target).display === 'none') {
            return slideDown(target, parent, duration);
        } else {
            return slideUp(target, parent, duration);
        }
    }

}

// Accordion Script to target and make active on click
let accordionWrappers = document.querySelectorAll('.js-accordions')

accordionWrappers?.forEach(accordionWrapper => {
    let accordions = accordionWrapper.querySelectorAll('summary');

    accordions.forEach(item => {
        item.addEventListener('click', toggleItem)
    });
})



function toggleItem(e) {
    e.preventDefault();

    const summary = e.currentTarget;
    const topBefore = summary.getBoundingClientRect().top;

    let item = e.target.closest('details')
    const parent = item.closest('.js-accordions');

    const isContentDesktopAlwaysOpen = parent.getAttribute('data-desktop-always-open') && parent.getAttribute('data-desktop-always-open') === 'true';
    const isContentMobileAlwaysOpen = parent.getAttribute('data-mobile-always-open') && parent.getAttribute('data-mobile-always-open') === 'true';

    if(isContentDesktopAlwaysOpen || isContentMobileAlwaysOpen) {
        if((isContentDesktopAlwaysOpen && window.innerWidth > 900) || (isContentMobileAlwaysOpen && window.innerWidth <= 900)) {
            if(!item.getAttribute('open')) {
                slideDown(item.querySelector('.accordion__content'), item)
            }
        } else {
            slideToggle(item.querySelector('.accordion__content'), item)
        }
    } else {
        slideToggle(item.querySelector('.accordion__content'), item)
    }

    for (let sibling of item.parentNode.parentNode.children) {
        if (sibling.querySelector('details') !== item) {
            slideUp(sibling.querySelector('.accordion__content'), sibling);
        }
    }

    setTimeout(() => {
        const header = document.querySelector('.header');
        const headerHeight = header?.getBoundingClientRect().height || 0;

        const rect = summary.getBoundingClientRect();

        const isVisible =
            rect.top >= headerHeight &&
            rect.bottom <= window.innerHeight;

        if (!isVisible) {
            window.scrollTo({
                top: window.scrollY + rect.top - headerHeight - 20,
                behavior: 'smooth'
            });
        }
    }, 400);

    const accordionId = item.getAttribute('data-accordion-id');

    if(accordionId) {
        if(parent && parent.querySelector(`[data-accordion-image-id="${accordionId}"]`)) {
            const image = parent.querySelector(`[data-accordion-image-id="${accordionId}"]`);

            parent.querySelectorAll('.js-accordion-image')?.forEach(accImage => {
                if(accImage === image) {
                    accImage.classList.add('active');
                } else {
                    accImage.classList.remove('active');
                }
            })
        }
    }
}